<script lang="ts">
	import { formatPrice } from '$lib/utils/formatPrice';
	import * as m from '$paraglide/messages';
	import { languageTag } from '$paraglide/runtime';
	import { createEventDispatcher } from 'svelte';

	export let amount = 0;
	export let currency = 'EUR';
	export let redirectUrl: string;
	export let index: number;

	const dispatch = createEventDispatcher<{
		handleRedirection: { roomPosition: number };
	}>();

	function handleRedirection(event: Event, redirectUrl: string) {
		event.stopPropagation();
		window.open(redirectUrl, '_blank', 'noopener');
		dispatch('handleRedirection', { roomPosition: index + 1 });
	}
</script>

<div
	role="button"
	tabindex={index}
	on:keypress={(event) => {
		if (event.key === 'Enter') {
			handleRedirection(event, redirectUrl);
		}
	}}
	class="flex p-2 bg-neutral-weak rd-1 flex-col justify-start items-start gap-2 cursor-pointer"
	on:click={(event) => {
		handleRedirection(event, redirectUrl);
	}}
>
	<div class="self-stretch text-sm text-coloredneutral-strongest clamp-lines-2 min-w-max">
		{m.poi_datasheet__availability_offer({ count: index + 1 })}
	</div>
	<div class="self-stretch text-sm text-bold text-origin">
		{formatPrice({ amount, currency, language: languageTag() })}
	</div>
</div>
